const cardItems = [
  {
    title: '某影帝深夜聚会照流出，身边神秘女子身份引发全网猜测',
    tag: '深度追踪',
    views: '89.2万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20feature%20card%20with%20warm%20terracotta%20and%20soft%20beige%20tones%20depicting%20celebrity%20lifestyle%20and%20mystery%20modern%20geometric%20composition%20with%20elegant%20lighting%20effects%20sophisticated%20magazine%20style%20design%20with%20subtle%20texture%20and%20warm%20atmosphere&width=400&height=260&seq=cards-01&orientation=landscape',
  },
  {
    title: '综艺节目黑幕大起底：某制作人独家讲述行业内幕',
    tag: '独家爆料',
    views: '76.5万',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20visual%20about%20television%20production%20and%20behind%20the%20scenes%20secrets%20warm%20amber%20and%20coral%20color%20palette%20with%20geometric%20shapes%20representing%20studio%20lights%20and%20cameras%20modern%20editorial%20style%20with%20rich%20gradients&width=400&height=260&seq=cards-02&orientation=landscape',
  },
  {
    title: '某流量小花三个月内连换三任经纪人，粉丝团集体抗议',
    tag: '艺人动态',
    views: '67.8万',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20image%20depicting%20entertainment%20industry%20changes%20and%20management%20drama%20warm%20rose%20and%20terracotta%20gradients%20with%20abstract%20flowing%20shapes%20modern%20magazine%20layout%20style%20with%20elegant%20composition%20and%20soft%20dramatic%20lighting&width=400&height=260&seq=cards-03&orientation=landscape',
  },
  {
    title: '品牌方连夜解约！某知名艺人被曝严重违约细节',
    tag: '商业爆料',
    views: '58.3万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20visual%20representing%20brand%20crisis%20and%20celebrity%20contract%20disputes%20warm%20copper%20and%20deep%20coral%20tones%20with%20bold%20diagonal%20composition%20editorial%20design%20featuring%20dramatic%20contrast%20and%20tension%20in%20sophisticated%20color%20palette&width=400&height=260&seq=cards-04&orientation=landscape',
  },
  {
    title: '某男团成员被爆私下言论录音引发轩然大波',
    tag: '热点追踪',
    views: '52.1万',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20editorial%20visual%20about%20music%20group%20controversy%20and%20entertainment%20news%20scandal%20warm%20terracotta%20and%20amber%20gradients%20with%20abstract%20sound%20wave%20patterns%20modern%20magazine%20cover%20style%20with%20bold%20geometric%20elements%20and%20sophisticated%20lighting&width=400&height=260&seq=cards-05&orientation=landscape',
  },
  {
    title: '某女艺人素颜直播翻车，真实容貌引发网友热议',
    tag: '娱乐现场',
    views: '48.9万',
    img: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20editorial%20card%20design%20about%20live%20streaming%20and%20social%20media%20trends%20warm%20coral%20and%20rose%20tone%20composition%20with%20soft%20glowing%20elements%20representing%20digital%20interaction%20sophisticated%20minimalist%20style%20with%20elegant%20gradients&width=400&height=260&seq=cards-06&orientation=landscape',
  },
  {
    title: '独家！某大导演与制片方彻底闹翻，投资方紧急撤资',
    tag: '独家内幕',
    views: '43.6万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20visual%20depicting%20film%20industry%20conflict%20and%20investment%20drama%20warm%20amber%20and%20deep%20terracotta%20tones%20with%20sharp%20geometric%20division%20lines%20modern%20magazine%20design%20style%20with%20dramatic%20contrast%20and%20sophisticated%20visual%20tension&width=400&height=260&seq=cards-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            51吃瓜视频编辑精选内容，不容错过的热门吃瓜文章
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cardItems.map((item, i) => (
            <div
              key={i}
              className={`group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-colors cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2 xl:col-span-2' : ''
              }`}
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className={`font-medium text-foreground-800 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2 ${
                  i === 0 ? 'text-base' : 'text-sm'
                }`}>
                  {item.title}
                </h3>
                <div className="flex items-center mt-3 text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>
                  <span>{item.views} 阅读</span>
                  <span className="mx-2">·</span>
                  <span>51吃瓜视频</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}